import { articleCards } from './articlesCards'

export const articleCardsNew = articleCards
  .map(el => {
    return {
      ...el,
      description: el.name,
    }
  })
  .reverse()
